(() => {
  if (window.CartSaleMix) return;

  const PREORDER = 'preorder';
  const REGULAR = 'regular';
  const CONFLICT_GROUPS = new Set([PREORDER, REGULAR]);

  const messages = () => {
    const locales = (window.KROWN && KROWN.settings && KROWN.settings.locales) || {};
    return {
      add: locales.cart_sale_mix_add_error || '同時に購入できません',
      conflict: locales.cart_sale_mix_conflict || '同時に購入できない商品があります。',
    };
  };

  const cartUpdateUrl = () => {
    const routes = (window.KROWN && KROWN.settings && KROWN.settings.routes) || {};
    return routes.cart_update_url || '/cart/update';
  };

  const fetchCartSaleGroups = async () => {
    const response = await fetch('?section_id=helper-cart-sale-groups');
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const jsonEl = doc.getElementById('CartSaleGroupsJson');
    if (!jsonEl) return [];
    try {
      const parsed = JSON.parse(jsonEl.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.warn('cart-sale-mix: parse', error);
      return [];
    }
  };

  const getBaseGroup = (items) => {
    for (let i = items.length - 1; i >= 0; i--) {
      if (items[i].group === PREORDER || items[i].group === REGULAR) {
        return items[i].group;
      }
    }
    return null;
  };

  const wouldConflict = (items, incomingGroup) => {
    if (!CONFLICT_GROUPS.has(incomingGroup)) return false;
    const base = getBaseGroup(items);
    if (!base) return false;
    return incomingGroup !== base;
  };

  const keysToRemove = (items) => {
    const base = getBaseGroup(items);
    if (!base) return [];
    const conflicting = base === PREORDER ? REGULAR : PREORDER;
    if (!items.some((item) => item.group === conflicting)) return [];
    return items.filter((item) => item.group === conflicting).map((item) => item.key);
  };

  const canAddProduct = async (group) => {
    if (!CONFLICT_GROUPS.has(group)) return true;
    try {
      const items = await fetchCartSaleGroups();
      if (wouldConflict(items, group)) {
        window.alert(messages().add);
        return false;
      }
    } catch (error) {
      console.warn('cart-sale-mix: canAddProduct', error);
    }
    return true;
  };

  let enforcing = false;

  const enforceCartMix = async ({ showAlert = true } = {}) => {
    if (enforcing) return false;
    enforcing = true;
    try {
      const items = await fetchCartSaleGroups();
      const keys = keysToRemove(items);
      if (keys.length === 0) return false;
      if (showAlert) {
        window.alert(messages().conflict);
      }
      const updates = {};
      keys.forEach((key) => {
        updates[key] = 0;
      });
      await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ updates }),
      });
      if (typeof window.refreshCart === 'function') {
        await window.refreshCart(false);
      } else {
        window.location.reload();
      }
      return true;
    } catch (error) {
      console.warn('cart-sale-mix: enforceCartMix', error);
      return false;
    } finally {
      enforcing = false;
    }
  };

  const wrapCartDrawerShow = () => {
    const Drawer = customElements.get('sidebar-drawer');
    if (!Drawer || Drawer.prototype.__cartSaleMixWrapped) return;
    const originalShow = Drawer.prototype.show;
    Drawer.prototype.show = async function (...args) {
      if (this.id === 'site-cart-sidebar') {
        await enforceCartMix({ showAlert: true });
      }
      return originalShow.apply(this, args);
    };
    Drawer.prototype.__cartSaleMixWrapped = true;
  };

  const init = () => {
    wrapCartDrawerShow();
    if (
      !customElements.get('sidebar-drawer') &&
      window.customElements &&
      customElements.whenDefined
    ) {
      customElements.whenDefined('sidebar-drawer').then(wrapCartDrawerShow);
    }
    if (document.body && document.body.classList.contains('template-cart')) {
      enforceCartMix({ showAlert: true });
    }
  };

  window.CartSaleMix = { canAddProduct, enforceCartMix };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
